module.exports = __webpack_public_path__ + "img/16.31978a5f.png";